import SectionCardWrapper from "@/templates/modern/elements/SectionCardWrapper";
import { FormattedDataType } from "@/templates/types";
import React from "react";
import AttributeValueCard from "./AttributeValueCard";
import { sectionMaxHeight } from "@/shared/utils/section-max-height";
import { sectionAspectRatio } from "@/shared/utils/aspect-ratio";

interface RenderAttributeCardProps {
  attributeValue: FormattedDataType["attributeValues"][0];
  section: Partial<FormattedDataType>;
  isSliderSection?: boolean;
  isOneElement?: boolean;
}

const RenderAttributeCard: React.FC<RenderAttributeCardProps> = ({
  attributeValue,
  section,
  isSliderSection,
  isOneElement,
}) => {
  return (
    <SectionCardWrapper
      isSlider={isSliderSection}
      data-test="attributeValue-card"
      background={section?.background}
      aspectRatio={sectionAspectRatio(attributeValue.image, isOneElement)}
      maxHeight={sectionMaxHeight(attributeValue.image, isOneElement)}
    >
      <AttributeValueCard
        attributeValue={attributeValue}
        hideTitle={!section?.showItemName}
      />
    </SectionCardWrapper>
  );
};

export default RenderAttributeCard;
